var CharCounter = (function() {
	var __private = {
		maxlength: "",
		text: "",
		result: "",

		set: function(args) {
			this.text = args.textarea;
			this.result = args.result;
			this.maxlength = args.max || 300;

			this.count(this.text.value.length);
		},

		count: function(N) {
			let num = this.maxlength - N;

			this.result.innerText = num;
		},

		input: function() {
			if(this.text.value.length > this.maxlength) {
				let val = this.text.value.slice(0, (this.maxlength - 3));
				val += "...";

				this.text.value = val;
				CharCounter.count(this.text.value.length);
			}

			this.text.addEventListener("input", function() {
				CharCounter.count(this.value.length);
			});
		}
	};


	return {
		run: function(args) {
			__private.set(args);
			__private.input();
		},

		count: function(N) {
			__private.count(N);
		}
	};
})();


(function() {
	document.addEventListener("DOMContentLoaded", function() {

		var forSale = document.getElementById("forSaleSign");

		if(forSale) {

			let textarea = document.querySelector("textarea[name=details]");
			let countEl  = document.getElementsByClassName("details-counter")[0];
			let maxLength= false;

			if(textarea) maxLength= +textarea.getAttribute("maxlength");

			if(maxLength && !isNaN(maxLength)) 
				CharCounter.run({
					textarea: textarea,
					result: countEl,
					max: maxLength
				});

		}
	});
})();